/**
 * Web Online Status Implementation
 * 
 * Uses navigator.onLine and window events to track connectivity.
 */
import { IOnlineStatus } from '@watchlist/shared';

export class WebOnlineStatus implements IOnlineStatus {
    isOnline(): boolean {
        return typeof navigator !== 'undefined' ? navigator.onLine : true;
    }

    subscribe(callback: (online: boolean) => void): () => void {
        const handleOnline = () => callback(true);
        const handleOffline = () => callback(false);

        window.addEventListener('online', handleOnline);
        window.addEventListener('offline', handleOffline);

        return () => {
            window.removeEventListener('online', handleOnline);
            window.removeEventListener('offline', handleOffline);
        };
    }
}
